/**
 * アイコン情報登録
 *
 * @export RegistCwsIconDataVo
 * @class RegistCwsIconDataVo
 */
export class RegistCwsIconDataVo {
    constructor(
        public iconCode: string,
        public iconName: string,
        public groupCode: string,
        public iconDiv: string,
        public arrangeDiv: string,
        public iconExplain: string,
        public outputDiv: string,
        public startOrderCode: string,
        public endOrderCode: string,
        public iconAlternativeText: string,
    ) {}
}
